import { Text, Heading, Button } from "./..";
import { Link } from "react-router-dom";
import React from "react";

export default function PricingPlanHeader({
  plantitle = "Starter",
  pricedescription = "Price for:",
  pricedetails = (
    <>
      Per machine
      <br />
      Compressor
      <br />
      Chillers
      <br />
      Manual Machine (Lathe, Welding, Milling)
      <br />
      Rotary Machine (Pumps)
    </>
  ),
  selectplanbuttontext = "Select Plan",
  ...props
}) {
  return (
    <div
      {...props}
      className="flex flex-col h-full gap-6 rounded-lg border-[1.5px] border-solid border-gray-300 bg-white p-6 mb-6"
    >
      {/* Plan Title */}
      <div className="flex flex-col items-center justify-center min-h-[50px]">
        <Heading
          size="headingmd"
          as="h6"
          className="text-[16px] font-bold text-blue_gray-800 md:text-[18px]"
        >
          {plantitle}
        </Heading>
      </div>

      {/* Price Details */}
      <div className="flex flex-col items-center justify-start gap-2 min-h-[120px] text-center">
        {/* <Heading
          size="headings"
          as="p"
          className="text-[15.23px] font-bold text-indigo-900 md:text-[20px]"
        >
          {pricedescription}
        </Heading> */}
        <Text
          size="textxl"
          as="p"
          className="text-[14px] font-normal text-gray-600 md:text-[16px]"
        >
          {pricedetails}
        </Text>
      </div>

      {/* Select Plan Button */}
      <div className="flex items-center justify-between mt-auto min-h-[50px]">
        <Link
          to="/contactus"
          style={{ textDecoration: "none", cursor: "pointer" }}
        >
          <Button
            size="md"
            className="rounded-md px-[34px] py-2 font-bold text-white bg-blue-600 hover:bg-blue-700"
          >
            {selectplanbuttontext}
          </Button>
        </Link>
      </div>
    </div>
  );
}
